import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { PresentationType } from '../../../../../../samwebDescription/samweb/settings/presentationType';
import { TabPositionType } from '../../../../../../samwebDescription/samweb/settings/tabBrick/tabPositionType';

export class ChangeBrickPosition {
   public static readonly type = '[TabBrickSettings] Change brick position';

   constructor(public brickInstanceId: string, public tabPosition: TabPositionType) {}
}

export class ChangeTabPresentation {
   public static readonly type = '[TabBrickSettings] Change Tab Presentation';

   constructor(public brickInstanceId: string, public tabPresentationType: PresentationType) {}
}

export class ChangeTabOrderForTabBrick {
   public static readonly type = '[TabBrickSettings] Change tab order for tab brick';

   constructor(public brickInstanceId: string, public oldIndex: number, public newIndex: number) {}
}

export class ChangeTabTitleForTabBrick {
   public static readonly type = '[TabBrickSettings] Change tab title for tab brick';

   constructor(public brickInstanceId: string, public tabId: string, public newTitle: string) {}
}

export class ChangeTabColorForTabBrick {
   public static readonly type = '[TabBrickSettings] Change tab color for tab brick';

   constructor(public brickInstanceId: string, public tabId: string, public newColor: string) {}
}

export class ChangeTabIconForTabBrick {
   public static readonly type = '[TabBrickSettings] Change tab icon for tab brick';

   constructor(public brickInstanceId: string, public tabId: string, public tabIcon: IconDefinition) {}
}

export class AddNewTabForTabBrick {
   public static readonly type = '[TabBrickSettings] Add new tab for tab brick';

   constructor(public brickInstanceId: string) {}
}

export class ChangeBrickDefinitionMenuOpeningStateForBrickTab {
   public static readonly type = '[TabBrickSettings] Change brick definition menu opening state';

   constructor(public brickInstanceId: string, public isOpen: boolean) {}
}

export class ToggleBrickDefinitionMenuOpeningStateForBrickTab {
   public static readonly type = '[TabBrickSettings] Toggle brick definition menu opening state';

   constructor(public brickInstanceId: string) {}
}

export class RemoveTabForTabBrick {
   public static readonly type = '[TabBrickSettings] Remove tab for tab brick';

   constructor(public brickInstanceId: string, public tabId: string, public brickInstanceIdToRemove: string) {}
}
